"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLCustomElement = class extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    init() { }
};
//# sourceMappingURL=html-custom-element.js.map